import React from 'react';

import { Table } from '@betterment/samba-react';

interface Props {
  planName?: string;
  isLastIndex: boolean;
}
const BillingPlanTableBodyRowCell: React.FC<React.PropsWithChildren<Props>> = ({ planName, isLastIndex, children }) => (
  <Table.Cell
    aria-label={planName}
    css={{
      flexBasis: '1/3',
      flexShrink: 0,
      flexGrow: 0,
      minWidth: '5rem',
      textWrap: 'nowrap',
      textSizeAdjust: '100%',
      borderBottomStyle: 'solid',
      borderBottomWidth: isLastIndex ? 0 : '.1rem',
      borderBottomColor: 'border.weak',
      pl: '0',
      pr: 'space.150',
    }}
  >
    {' '}
    {children}
  </Table.Cell>
);

export default BillingPlanTableBodyRowCell;
